"use strict";
// @ts-ignore
try {
    self['workbox:core:7.4.1'] && _();
}
catch (e) { }
